
















































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import {
  TransferScheduleWeekDay,
  ContributionFrequencyType,
  RecurringSchedule,
  TransferScheduleMonthBoundary,
  TransferScheduleType
} from "@/shared/types";
import moment from "moment";
import _ from "lodash";

const defaultSchedule: RecurringSchedule = {
  scheduleType: TransferScheduleType.Weekly,
  scheduleInterval: 1,
  dates: [],
  dayOfWeek: TransferScheduleWeekDay.Monday,
  scheduleMonthBoundary: TransferScheduleMonthBoundary.First,
  days: [],
};

@Component
export default class ScheduleFrequencySelect extends Vue {
  @Prop()
  value: RecurringSchedule;

  ContributionFrequencyType = ContributionFrequencyType;
  PersonalContributionScheduleWeekDay = TransferScheduleWeekDay;
  PersonalContributionScheduleMonthBoundary = TransferScheduleMonthBoundary;
  PersonalContributionScheduleType = TransferScheduleType;

  lastDay = "Last";
  schedule: RecurringSchedule = null;

  mounted () {
    this.onValueChange(this.value);
  }

  @Watch("value", { deep: true })
  onValueChange (value) {
    value = value === null || Object.keys(value).length === 0
        ? _.cloneDeep(defaultSchedule)
        : _.cloneDeep(value);

    if (_.isEqual(this.schedule, value)) {
      return;
    }

    this.schedule = value;
  }

  get scheduleType (): TransferScheduleType {
    return this.schedule.scheduleType;
  }

  set scheduleType (type: TransferScheduleType) {
    this.schedule.scheduleType = type;
    if (this.schedule.scheduleType === TransferScheduleType.Weekly) {
      this.schedule.dates = [];
      this.schedule.dayOfWeek = null;
      this.schedule.scheduleMonthBoundary = null;
    }

    if (this.schedule.scheduleType === TransferScheduleType.MonthlyByDay) {
      this.schedule.dates = [];
      this.schedule.days = [];
      this.schedule.dayOfWeek = TransferScheduleWeekDay.Monday;
      this.schedule.scheduleMonthBoundary = TransferScheduleMonthBoundary.First;
    }

    if (this.schedule.scheduleType === TransferScheduleType.MonthlyByDate) {
      this.schedule.days = [];
      this.schedule.dayOfWeek = null;
      this.schedule.scheduleMonthBoundary = null;
    }
  }

  get frequencyType (): ContributionFrequencyType {
    return this.schedule.scheduleType === TransferScheduleType.Weekly
        ? ContributionFrequencyType.Week
        : ContributionFrequencyType.Month;
  }

  set frequencyType (type: ContributionFrequencyType) {
    this.schedule.scheduleInterval = 1;
    this.schedule.scheduleType = type === ContributionFrequencyType.Week
        ? TransferScheduleType.Weekly
        : TransferScheduleType.MonthlyByDate;
    this.onScheduleChange();
  }

  range (start: number, end: number) {
    return _.range(start, end);
  }

  get maxFrequency () {
    return this.frequencyType === ContributionFrequencyType.Month ? 12 : 4;
  }

  get showMonthSelection () {
    return this.frequencyType === ContributionFrequencyType.Month;
  }

  get showMonthDaySelection () {
    return this.schedule.scheduleType === TransferScheduleType.MonthlyByDay;
  }

  get showDateSelection () {
    return this.schedule.scheduleType === TransferScheduleType.MonthlyByDate;
  }

  get showWeekSelection () {
    return this.schedule.scheduleType === TransferScheduleType.Weekly;
  }

  @Watch("schedule", {deep: true})
  onScheduleChange () {
    this.$emit("input", this.schedule);
  }

  onDateClicked (date: string) {
    if (!this.schedule.dates.includes(date)) {
      this.schedule.dates.push(date);
    }
    else {
      const index = this.schedule.dates.indexOf(date);
      this.schedule.dates.splice(index, 1);
    }
  }

  isDateSelected (date: string) {
    return this.schedule.dates.includes(date);
  }
}
